export default __webpack_public_path__ + "static/media/photo--lg--62.0344c3fc.jpg";